import { CoreApi, Product, Dimension } from '@inter-ikea-storageone/range';
import { Entity, ComponentIds } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';
import * as R from 'ramda';

export const getSectionSizesInScene = (dimension: Dimension, coreApi: CoreApi): number[] => {
  const sectionsInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  if (dimension === 'height') {
    return R.uniq(
      sectionsInScene.map(
        section =>
          section.getComponent<CommunicationSizeComponent>(
            ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
          )?.size?.height || 0
      )
    );
  }
  if (dimension === 'width') {
    return R.uniq(
      sectionsInScene.map(
        section =>
          section.getComponent<CommunicationSizeComponent>(
            ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
          )?.size?.width || 0
      )
    );
  }
  return R.uniq(
    sectionsInScene.map(
      section =>
        section.getComponent<CommunicationSizeComponent>(
          ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
        )?.size?.depth || 0
    )
  );
};

export const changeSectionSize = (
  coreApi: CoreApi,
  matchingSections: Product[],
  dimension: number,
  oldEntity: Entity,
  dimensionType: Dimension
): Entity | null => {
  let newSectionEntity = null;
  // Select a section with the new height
  const nextSection = matchingSections.find(
    section => section.communicatedDimensions[dimensionType] === dimension
  );
  if (!nextSection) return null;

  const allowedMovementOfChildrenInMilliMeter = dimensionType === 'height' ? 1 : Number.MAX_VALUE;
  const replaceInvalidEntities = dimensionType === 'height' ? false : true;
  newSectionEntity = coreApi.products.replaceEntityWithHierarchy(
    oldEntity.id,
    nextSection.coreProductId,
    replaceInvalidEntities,
    allowedMovementOfChildrenInMilliMeter
  );

  return newSectionEntity;
};
